export default [
  {
    path:'/admin/goods/list',
    name:'GoodsList',
    component:()=>import('../views/goods/list'),
    meta:{
      title:'商品列表',
      keepAlive: false,
    }
  },
  {
    path:'/admin/goods/category',
    name:'GoodsCategory',
    component:()=>import('../views/goods/category'),
    meta:{
      title:'商品分类',
      keepAlive:false
    }
  },
  {
    path:'/admin/goods/service',
    name:'GoodsService',
    component:()=>import('../views/goods/service'),
    meta:{
      title:'商品服务',
      keepAlive:false
    }
  },
  {
    path:'/admin/goods/edit',
    name:'GoodsEdit',
    component:()=>import('../views/goods/edit'),
    meta:{
      title:'商品编辑',
      keepAlive: false
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/goods.js